import { Component, createRef } from "react";
import { connect } from "react-redux";

import {
  set_datapage,
  getMapStateDefault,
} from "@ora/recursos/src/redux/actions/DataPageAction";
import { Templates } from "@ora/recursos";
import {
  checkDataDirectorio,
  // seDataDirectorio,
  seDatatDocumentos,
} from "@ora/recursos/src/redux/actions/DirectoriosActions";
import Swal from "sweetalert2";
import { Button, Card, Section, Form } from "react-bulma-components";
import axios from "axios";
import { baseUrl, localUrl } from "@ora/recursos/src/helpers/Url";

class ExportadoresCreate extends Component {
  isEdit = false;
  idrecurso = 0;
  state = {
    pais: [],
    idioma: [],
    institucion: [],
    sublinea: [],
    data: null,
  };
  constructor(props) {
    super(props);
    console.log(this.props);

    this.props.set_datapage({
      titulo: "Nuevo Exportador",
      isbackend: true,
      breadcrumb: [
        { name: "Intranet", url: "#" },
        { name: "Config", url: "#" },
        { name: "Nuevo Exportador", url: "#", active: true },
      ],
    });
    this.frmCreate = createRef();
    let { idrecurso } = this.props.match.params;
    if (idrecurso !== undefined) {
      this.isEdit = true;
      this.idrecurso = idrecurso;
    }
  }

  componentDidMount() {
    console.log("mounteds");
    axios
      .get(baseUrl("cites/exportador"))
      .then((res) => {
        if (res.data.success) {
          this.setState({
            pais: res.data.data.pais,
            idioma: res.data.data.idioma,
            institucion: res.data.data.institucion,
          });
        }
      })
      .then((success) => {
        if (this.isEdit) {
          axios
            .get(baseUrl("cites/exportador/" + this.idrecurso))
            .then((res) => {
              if (res.data.success) {
                // this.setState({
                //     data: res.data.data
                // })
                this.frmCreate.current.elements.ins_int_id.value =
                  res.data.data.ins_int_id;
                this.frmCreate.current.elements.per_txt_name.value =
                  res.data.data.per_txt_name;
                this.frmCreate.current.elements.per_txt_last_name.value =
                  res.data.data.per_txt_last_name;
                this.frmCreate.current.elements.per_txt_sex.value =
                  res.data.data.per_txt_sex;
                this.frmCreate.current.elements.per_txt_phone.value =
                  res.data.data.per_txt_phone;
                this.frmCreate.current.elements.per_txt_email.value =
                  res.data.data.per_txt_email;

                this.frmCreate.current.elements.pai_int_id.value =
                  res.data.data.pai_int_id;

                this.frmCreate.current.elements.lan_txt_language.value =
                  res.data.data.lan_txt_language;
              }
            });
        }
      });
  }
  componentDidUpdate() {
    console.log("update");
  }
  onClick_regresar = (evt) => {
    this.props.history.push(localUrl("/config/exportadores"));
  };
  OnSubmit_create = (evt) => {
    evt.preventDefault();
    let data = new FormData(this.frmCreate.current);
    axios({
      method: this.isEdit ? "put" : "post",
      url: baseUrl(
        "cites/exportador" + (this.isEdit ? `/${this.idrecurso}` : "")
      ),
      data: this.isEdit ? Object.fromEntries(data) : data,
    }).then((res) => {
      if (res.data.success) {
        this.frmCreate.current.reset();
        Swal.fire("Exportadores", res.data.message, "success").then((sr) => {
          if (this.isEdit) {
            this.onClick_regresar();
            // this.props.history.push(localUrl('config/recursos'))
          }
        });
      }
    });
  };

  COptionPais = () => {
    return this.state.pais.map((item, index) => {
      return (
        <option key={index} value={item.id}>
          {item.name}
        </option>
      );
    });
  };
  COptionLenguaje = () => {
    return this.state.idioma.map((item, index) => {
      return (
        <option key={index} value={item.id}>
          {item.name}
        </option>
      );
    });
  };
  COptionInstitucion = () => {
    return this.state.institucion.map((item, index) => {
      return (
        <option key={index} value={item.id}>
          {item.name}
        </option>
      );
    });
  };

  render() {
    return (
      <Templates.Default.BasePageRoute2
      localUrl={localUrl}
      dataPage={this.props.DataPage}
    >
      <div className="is-main-section">
        <Card>
          <Card.Header>
            <Card.Header.Title>
              <span className="icon">
                <i className="fas fa-file-invoice"></i>
              </span>
              Datos
            </Card.Header.Title>
          </Card.Header>
          <Card.Content>
            <form ref={this.frmCreate} onSubmit={this.OnSubmit_create}>
              <div className="field is-horizontal">
                <div className="field-label is-normal">
                  <label className="label">Institucion</label>
                </div>
                <div className="field-body">
                  <div className="field">
                    <div className="control">
                      <span className="select is-empty">
                        <select
                          required="required"
                          name="ins_int_id"
                          disabled={this.state.institucion.length === 0}
                        >
                          <option value="-1">- Seleccionar -</option>
                          {this.COptionInstitucion()}
                        </select>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal">
                  <label className="label">Nombre</label>
                </div>
                <div className="field-body">
                  <div className="field columns">
                    <div className="field column is-8">
                      <div className="control   is-clearfix">
                        <input
                          type="text"
                          placeholder="Nombre"
                          name="per_txt_name"
                          required="required"
                          className="input form-control"
                          maxLength="50"
                        />
                      </div>
                      <p className="help">0 / 50 </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal">
                  <label className="label">Apellido</label>
                </div>
                <div className="field-body">
                  <div className="field columns">
                    <div className="field column is-8">
                      <div className="control   is-clearfix">
                        <input
                          type="text"
                          placeholder="Nombre"
                          name="per_txt_last_name"
                          required="required"
                          className="input form-control"
                          maxLength="100"
                        />
                      </div>
                      <p className="help">0 / 100 </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal">
                  <label className="label">Sexo</label>
                </div>
                <div className="field-body">
                  <div className="field">
                    <div className="control">
                      <span className="select is-empty">
                        <select required="required" name="per_txt_sex">
                          <option value="-1">- Seleccionar -</option>
                          <option value="M">Masculino</option>
                          <option value="F">Femenino</option>
                        </select>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal">
                  <label className="label">Telefono</label>
                </div>
                <div className="field-body">
                  <div className="field columns">
                    <div className="field column is-4">
                      <div className="control is-clearfix">
                        <input
                          type="text"
                          placeholder="Telefono"
                          name="per_txt_phone"
                          required="required"
                          className="input form-control"
                          maxLength="19"
                        />
                      </div>
                      <p className="help">0 / 19 </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal">
                  <label className="label">Correo</label>
                </div>
                <div className="field-body">
                  <div className="field columns">
                    <div className="field column is-8">
                      <div className="control   is-clearfix">
                        <input
                          type="text"
                          placeholder="Nombre"
                          name="per_txt_email"
                          required="required"
                          className="input form-control"
                          maxLength="100"
                        />
                      </div>
                      <p className="help">0 / 100 </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal">
                  <label className="label">Pais</label>
                </div>
                <div className="field-body">
                  <div className="field">
                    <div className="control">
                      <span className="select is-empty">
                        <select
                          required="required"
                          name="pai_int_id"
                          disabled={this.state.pais.length === 0}
                        >
                          <option value="-1">- Seleccionar -</option>
                          {this.COptionPais()}
                        </select>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <input type="hidden" name="var_int_id" value="54" />

              <div className="field is-horizontal">
                <div className="field-label is-normal">
                  <label className="label">Idioma</label>
                </div>
                <div className="field-body">
                  <div className="field">
                    <div className="control">
                      <span className="select is-empty">
                        <select
                          required="required"
                          name="lan_txt_language"
                          disabled={this.state.idioma.length === 0}
                        >
                          <option value="-1">- Seleccionar -</option>
                          {this.COptionLenguaje()}
                        </select>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div className="field is-horizontal">
                <div className="field-label is-normal" />
                <div className="field-body">
                  <div className="field">
                    <div className="field">
                      <div className="field-body">
                        <div className="field is-grouped">
                          <div className="control">
                            <button type="submit" className="button is-primary">
                              <span>Guardar</span>
                            </button>
                          </div>
                          <div className="control">
                            <button
                              type="button"
                              onClick={this.onClick_regresar}
                              className="button is-danger"
                            >
                              <span>Regresar</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </Card.Content>
        </Card>
      </div>
      </Templates.Default.BasePageRoute2>
    );
  }
}
export default connect(getMapStateDefault(), {
  set_datapage,
  seDatatDocumentos,
  checkDataDirectorio,
})(ExportadoresCreate);
